/* eslint-disable prefer-destructuring */
import { useContext } from 'react';
import { useRouter } from 'next/router';
import { MPosContext } from 'utils/context';
import { Partners } from 'utils/constants';

export const useFetchParams = () => {
    const router = useRouter();
    const { partnerId } = useContext(MPosContext);

    const { slug }: any = router.query;

    let route = '';
    let lob = partnerId === Partners.HERO_VIDA ? 'auto-lob' : 'embedded';
    let partner = '';

    if (!slug) {
        return {
            route,
            partner,
            lob,
        };
    }

    if (slug.length < 2) {
        route = 'error';
    } else {
        route = slug[2];
        partner = slug[1];
        lob = slug[0];
    }
    return {
        route,
        partner,
        lob,
    };
};
